module.exports = __webpack_public_path__ + "img/img11.2e508044.png";